<h2 mat-dialog-title>
  <i class="fa fa-globe" aria-hidden="true"></i>
  Select Docs Country
</h2>

<mat-dialog-content>
  <p class="mb-3">{{ data.message ?? 'You have selected INVENTORY as your buyer. Please select your Docs Country below.' }}</p>

  <form [formGroup]="form">
    <tc-select-search
      placeholder="Select Docs Country"
      [group]="form"
      ctrlName="docsCountryCode"
      [items]="data.countries"
      bindValue="code"
      bindLabel="name"
    >
      @if (docsCountryIssues$ | async; as issues) {
        <tc-validation-warning [text]="issues" />
      }
    </tc-select-search>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button" mat-button (click)="onCancel()">
    Cancel
  </button>
  <button type="button" mat-raised-button color="primary" (click)="onConfirm()" [disabled]="form.invalid">
    <i class="fa fa-check"></i> OK
  </button>
</mat-dialog-actions>
